export const FETCH_SALES_CONTRACT_DETAILS_SUCCESS = 'FETCH_SALES_CONTRACT_DETAILS_SUCCESS';
export const FETCH_SALES_CONTRACT_DETAILS_FAILURE = 'FETCH_SALES_CONTRACT_DETAILS_FAILURE';
